// context/AuthContext.js
import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userdata, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem("userdata");
      return stored ? JSON.parse(stored) : null;
    } catch (err) {
      console.error("Invalid JSON in localStorage:", err);
      return null;
    }
  });

  // modal state: open/close + which tab
  const [authModal, setAuthModal] = useState({ open: false, tab: "login" });

  const login = (data) => {
    setUser(data.userdata);
    localStorage.setItem("userdata", JSON.stringify(data.userdata));
    if (data.token) {
      localStorage.setItem("token", data.token);
    }
    setAuthModal({ open: false, tab: "login" }); // close modal
  };

  const signup = (data) => {
    setUser(data.userdata);
    localStorage.setItem("userdata", JSON.stringify(data.userdata));
    if (data.token) {
      localStorage.setItem("token", data.token);
    }
    setAuthModal({ open: false, tab: "signup" }); // close modal after signup
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("userdata");
  };

  return (
    <AuthContext.Provider
      value={{ userdata, login, signup, logout, authModal, setAuthModal }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
